module.exports = __webpack_public_path__ + "img/autonomous.206aef4f.jpg";